import React from 'react'

export const RichCardSvg = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 31 38"
      {...props}
    >
      <path
        d="M4 1H27C28.6569 1 30 2.34315 30 4V34C30 35.6569 28.6569 37 27 37H4C2.34315 37 1 35.6569 1 34V4C1 2.34315 2.34315 1 4 1Z"
        stroke="current"
        fill="none"
        strokeWidth={2}
      />
      <path
        d="M4.5 29.5C19.7 29.5 25.6667 29.5 26 29.5M4.5 27H26M4.5 32H26"
        stroke="current"
        fill="none"
      />
      <path
        d="M24.2664 15.9144L21.5276 10.7294C21.0289 9.7802 20.2851 9.24187 19.4364 9.20645C18.5964 9.17104 17.7826 9.64562 17.1614 10.5523L15.4989 12.9677C15.1489 13.4777 14.6501 13.7823 14.1076 13.8177C13.5563 13.8602 13.0051 13.6265 12.5588 13.1661L12.3663 12.9677C11.7451 12.3373 10.9751 12.0327 10.1876 12.0965C9.40009 12.1602 8.72634 12.5994 8.28009 13.3148L6.76634 15.7586C6.22384 16.644 6.27634 17.6711 6.91509 18.5069C7.55384 19.3427 8.66509 19.8456 9.88134 19.8456H21.0464C22.2189 19.8456 23.3126 19.3711 23.9601 18.5777C24.6251 17.7844 24.7301 16.7856 24.2664 15.9144Z"
        fill="current"
        stroke="none"
      />
      <path
        d="M11.0986 9.93662C12.732 9.93662 14.0561 8.86472 14.0561 7.54245C14.0561 6.22019 12.732 5.14828 11.0986 5.14828C9.46523 5.14828 8.14111 6.22019 8.14111 7.54245C8.14111 8.86472 9.46523 9.93662 11.0986 9.93662Z"
        fill="current"
        stroke="none"
      />
    </svg>
  )
}
export const EyeSvg = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 46 41"
      fill="none"
      stroke="currentColor"
      {...props}
    >
      <path
        d="M17.249 20.5c0 2.83 2.574 5.125 5.75 5.125 3.175 0 5.75-2.294 5.75-5.125 0-2.83-2.575-5.125-5.75-5.125-3.176 0-5.75 2.294-5.75 5.125Z"
        strokeWidth={5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.998 8.542c8.582 0 15.847 5.027 18.289 11.958-2.442 6.93-9.707 11.958-18.29 11.958-8.581 0-15.846-5.027-18.289-11.958 2.443-6.93 9.708-11.958 18.29-11.958Z"
        strokeWidth={5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export const ClickSvg = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={41}
      height={41}
      viewBox="0 0 41 41"
      fill="none"
      {...props}
    >
      <path
        d="M29.161 35.209H16.725a3.417 3.417 0 1 1 0-6.834h3.194L8.542 16.845a3.417 3.417 0 0 1-.325-4.528 3.211 3.211 0 0 1 2.511-1.162 3.144 3.144 0 0 1 2.307.94l6.935 6.936 6.97-5.228a3.263 3.263 0 0 1 4.271.308 29.349 29.349 0 0 1 7.09 11.514l.102.325"
        stroke="#29275D"
        strokeWidth={3}
        strokeMiterlimit={10}
      />
      <path
        d="M18.16 17.288a8.08 8.08 0 0 0 .632-3.33 8.166 8.166 0 1 0-8.098 8.25 7.977 7.977 0 0 0 2.648-.444"
        stroke="#29275D"
        strokeWidth={3}
        strokeMiterlimit={10}
      />
    </svg>
  )
}

export const DoubleCheckSvg = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={46}
      height={49}
      viewBox="0 0 46 49"
      fill="none"
      {...props}
    >
      <path
        d="M25.3383 33.6875L40.25 15.3125"
        stroke="#6B6997"
        strokeWidth={5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.75 24.255L13.4167 33.6875L28.3283 15.3125"
        stroke="#6B6997"
        strokeWidth={5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export const WebSvg = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="current"
      {...props}
    >
      <path
        d="M25.6066 4.39336C22.7735 1.56023 19.0066 0 15 0C10.9934 0 7.22654 1.56023 4.39336 4.39336C1.56018 7.22648 0 10.9934 0 15C0 19.0066 1.56023 22.7735 4.39336 25.6066C7.22648 28.4398 10.9934 30 15 30C19.0066 30 22.7735 28.4398 25.6066 25.6066C28.4398 22.7735 30 19.0066 30 15C30 10.9934 28.4398 7.22654 25.6066 4.39336ZM25.4817 22.8902C24.5846 22.2831 23.6456 21.7585 22.672 21.3205C23.1021 19.6437 23.3574 17.8232 23.4211 15.9375H28.0911C27.9069 18.5353 26.9636 20.9266 25.4817 22.8902ZM1.90887 15.9375H6.57891C6.64266 17.8232 6.89801 19.6438 7.32797 21.3205C6.35438 21.7585 5.41535 22.283 4.51828 22.8902C3.03645 20.9266 2.09309 18.5353 1.90887 15.9375ZM4.51805 7.11012C5.41512 7.71727 6.35414 8.24186 7.32785 8.67984C6.89789 10.3565 6.6426 12.1769 6.57885 14.0625H1.90887C2.09309 11.4648 3.03639 9.07371 4.51805 7.11012ZM21.1305 4.61514C20.787 3.97107 20.4158 3.38988 20.021 2.87414C21.6071 3.53332 23.037 4.49473 24.2384 5.68647C23.5573 6.134 22.8496 6.5284 22.12 6.86918C21.8337 6.06855 21.5031 5.31369 21.1305 4.61514ZM20.3708 7.5685C18.6592 8.14225 16.8529 8.4375 15 8.4375C13.1471 8.4375 11.3408 8.14225 9.62918 7.5685C10.8282 4.15524 12.8092 1.875 15 1.875C17.1908 1.875 19.1718 4.15524 20.3708 7.5685ZM8.45525 14.0625C8.51713 12.4018 8.74148 10.8152 9.09609 9.3682C10.9791 9.99188 12.9643 10.3125 15 10.3125C17.0357 10.3125 19.0209 9.99188 20.9039 9.3682C21.2586 10.8152 21.4829 12.4018 21.5447 14.0625H8.45525ZM21.5447 15.9375C21.4828 17.5983 21.2585 19.185 20.9038 20.632C19.0207 20.0082 17.0355 19.6875 15 19.6875C12.9645 19.6875 10.9793 20.0082 9.09615 20.632C8.74148 19.185 8.51713 17.5983 8.45525 15.9375H21.5447ZM8.86951 4.61514C8.49697 5.31369 8.16639 6.06855 7.88004 6.86912C7.15043 6.5284 6.44273 6.13395 5.76158 5.68641C6.96293 4.49461 8.39285 3.53326 9.97898 2.87408C9.58424 3.38988 9.21299 3.97107 8.86951 4.61514ZM7.8801 23.1312C8.16639 23.9317 8.49697 24.6864 8.86945 25.3849C9.21299 26.0289 9.58418 26.6101 9.97893 27.1259C8.39297 26.4667 6.96316 25.5054 5.76188 24.3138C6.44303 23.8663 7.15061 23.472 7.8801 23.1312ZM9.6293 22.4317C11.341 21.8579 13.1473 21.5625 15 21.5625C16.8527 21.5625 18.659 21.8579 20.3707 22.4317C19.1717 25.8449 17.1907 28.125 15 28.125C12.8093 28.125 10.8283 25.8449 9.6293 22.4317ZM21.1305 25.3849C21.503 24.6864 21.8336 23.9317 22.1198 23.1312C22.8494 23.472 23.557 23.8664 24.2381 24.3138C23.0368 25.5054 21.607 26.4667 20.021 27.1259C20.4158 26.6101 20.787 26.0289 21.1305 25.3849ZM23.4211 14.0625C23.3573 12.177 23.1021 10.3565 22.6721 8.67984C23.6458 8.24186 24.5849 7.71727 25.4819 7.11012C26.9636 9.07365 27.9069 11.4647 28.0911 14.0625H23.4211Z"
        fill="current"
        stroke="none"
      />
    </svg>
  )
}

export const VectorVSvg = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={21}
      height={10}
      viewBox="0 0 21 10"
      fill="none"
      {...props}
    >
      <path d="M20 1.5L10.5 8.5L1 1.5" stroke="white" strokeWidth={2} />
    </svg>
  )
}

export const CarouselSvg = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 36 43"
      fill="none"
      {...props}
    >
      <path
        d="M4 6H27C28.6569 6 30 7.34315 30 9V39C30 40.6569 28.6569 42 27 42H4C2.34315 42 1 40.6569 1 39V9C1 7.34315 2.34315 6 4 6Z"
        stroke="current"
        fill="none"
        strokeWidth={2}
      />
      <path
        d="M4.5 34.5C19.7 34.5 25.6667 34.5 26 34.5M4.5 32H26M4.5 37H26"
        stroke="current"
        strokeWidth={2}
        fill="none"
      />
      <path
        d="M7 3.92105V3.92105C7 2.3078 8.3078 1 9.92105 1H32C33.6569 1 35 2.34315 35 4V35C35 36.6569 33.6569 38 32 38V38"
        stroke="current"
        fill="none"
        strokeWidth={2}
      />
      <path
        d="M24.2664 20.9144L21.5276 15.7294C21.0289 14.7802 20.2851 14.2419 19.4364 14.2065C18.5964 14.171 17.7826 14.6456 17.1614 15.5523L15.4989 17.9677C15.1489 18.4777 14.6501 18.7823 14.1076 18.8177C13.5563 18.8602 13.0051 18.6265 12.5588 18.1661L12.3663 17.9677C11.7451 17.3373 10.9751 17.0327 10.1876 17.0965C9.40009 17.1602 8.72634 17.5994 8.28009 18.3148L6.76634 20.7586C6.22384 21.644 6.27634 22.6711 6.91509 23.5069C7.55384 24.3427 8.66509 24.8456 9.88134 24.8456H21.0464C22.2189 24.8456 23.3126 24.3711 23.9601 23.5777C24.6251 22.7844 24.7301 21.7856 24.2664 20.9144Z"
        fill="current"
        stroke="none"
      />
      <path
        d="M11.0986 14.9366C12.732 14.9366 14.0561 13.8647 14.0561 12.5425C14.0561 11.2202 12.732 10.1483 11.0986 10.1483C9.46523 10.1483 8.14111 11.2202 8.14111 12.5425C8.14111 13.8647 9.46523 14.9366 11.0986 14.9366Z"
        fill="current"
        stroke="none"
      />
    </svg>
  )
}
export const TextSvg = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 22 22"
      fill="none"
      {...props}
    >
      <path
        d="M7.667 21H11m0 0h3.333M11 21V1m0 0H1v1.429M11 1h10v1.429"
        stroke="current"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const ImageIcon = (props) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 46 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="current"
    {...props}
  >
    <path
      d="M26.5315 30.5L19.3552 20.3338C18.2122 18.7145 17.6409 17.9051 16.9381 17.6322C16.3235 17.3936 15.6396 17.4074 15.0351 17.6706C14.3439 17.9716 13.8056 18.8035 12.729 20.4673L3.64342 34.5088C3.40492 34.8773 3.28568 35.0618 3.2012 35.2603C3.12625 35.4365 3.0718 35.6208 3.03893 35.8095C3.00188 36.022 3.00182 36.2417 3.0017 36.6807L3 43H43.002V36.651C43.002 36.2227 43.002 36.0087 42.9668 35.801C42.9355 35.6167 42.8835 35.4365 42.8123 35.2638C42.7315 35.069 42.6177 34.8878 42.3902 34.525L39.975 30.6755C37.8405 27.2737 36.7733 25.5728 35.3863 24.9528C34.1738 24.4105 32.7953 24.373 31.5553 24.8488C30.1368 25.3925 28.9788 27.033 26.6628 30.314L26.5315 30.5ZM26.5315 30.5L35.3863 43M43.002 8C43.002 10.7614 40.7635 13 38.002 13C35.2405 13 33.002 10.7614 33.002 8C33.002 5.23857 35.2405 3 38.002 3C40.7635 3 43.002 5.23857 43.002 8Z"
      strokeWidth={5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const PhoneIcon = (props) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 45 43"
    fill="current"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M31.3905 27.2655L30.2517 28.3975C30.2517 28.3975 27.5452 31.0887 20.1577 23.743C12.7703 16.3975 15.4767 13.7064 15.4767 13.7064L16.1937 12.9934C17.9602 11.2371 18.1267 8.41727 16.5855 6.35869L13.4331 2.14769C11.5257 -0.400209 7.83989 -0.736783 5.65362 1.43707L1.72962 5.33879C0.645571 6.41669 -0.0808795 7.81397 0.0072205 9.36402C0.232595 13.3295 2.02677 21.8617 12.0384 31.8165C22.6552 42.373 32.617 42.7925 36.6907 42.4127C37.9792 42.2927 39.0997 41.6365 40.0027 40.7385L43.5542 37.2075C45.9515 34.8237 45.2755 30.7372 42.2082 29.07L37.432 26.4735C35.418 25.3787 32.9645 25.7002 31.3905 27.2655Z"
      fill="current"
      stroke="none"
    />
  </svg>
)

export const MessageIcon = (props) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 7.2C3 6.07989 3 5.51984 3.21799 5.09202C3.40973 4.71569 3.71569 4.40973 4.09202 4.21799C4.51984 4 5.0799 4 6.2 4H17.8C18.9201 4 19.4802 4 19.908 4.21799C20.2843 4.40973 20.5903 4.71569 20.782 5.09202C21 5.51984 21 6.0799 21 7.2V20L17.6757 18.3378C17.4237 18.2118 17.2977 18.1488 17.1656 18.1044C17.0484 18.065 16.9277 18.0365 16.8052 18.0193C16.6672 18 16.5263 18 16.2446 18H6.2C5.07989 18 4.51984 18 4.09202 17.782C3.71569 17.5903 3.40973 17.2843 3.21799 16.908C3 16.4802 3 15.9201 3 14.8V7.2Z"
      stroke="current"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const RbmSimpleTypeSvg = (props) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 212 104"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.15633 3.71266C4.42133 2.66635 5.1631 0 7.18918 0H196C204.837 0 212 7.16345 212 16V88C212 96.8366 204.837 104 196 104H38.6911C29.8546 104 22.6911 96.8366 22.6911 88V19.896C22.6911 16.0409 20.673 12.4672 17.3718 10.4763L6.15633 3.71266Z"
      fill="#D9D9D9"
    />
    <path d="M114.5 22H185H44" stroke="black" strokeWidth={2} />
    <line x1={44} y1={41} x2={185} y2={41} stroke="black" strokeWidth={2} />
    <line x1={44} y1={61} x2={185} y2={61} stroke="black" strokeWidth={2} />
    <path d="M44 82H152" stroke="black" strokeWidth={2} />
    <line x1={153} y1={82} x2={185} y2={82} stroke="#9747FF" strokeWidth={2} />
  </svg>
)

export const RbmBasicTypeSvg = (props) => (
  <svg
    width={117}
    height={160}
    viewBox="0 0 117 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#a)">
      <path fill="#ECECEF" d="M.5 0h116v72H.5z" />
      <path
        d="m62.383 42.125-7.893-9.658c-1.257-1.538-1.886-2.307-2.659-2.566a3.15 3.15 0 0 0-2.093.036c-.76.286-1.352 1.076-2.537 2.657l-9.993 13.34c-.263.35-.394.525-.487.713a2 2 0 0 0-.178.522c-.04.202-.041.41-.041.828L36.5 54h44v-6.032c0-.406 0-.61-.039-.807a2 2 0 0 0-.17-.51c-.088-.185-.214-.358-.464-.702l-2.656-3.657c-2.348-3.232-3.522-4.848-5.048-5.437a6.3 6.3 0 0 0-4.214-.099c-1.56.517-2.834 2.075-5.381 5.192zm0 0L72.123 54M80.5 20.75c0 2.623-2.462 4.75-5.5 4.75s-5.5-2.127-5.5-4.75S71.964 16 75 16s5.5 2.127 5.5 4.75"
        stroke="#6562BE"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path fill="#fff" d="M.5 72h116v88H.5z" />
      <path stroke="#000" strokeWidth={2} d="M10.5 84h31" />
      <path
        stroke="#000"
        strokeOpacity={0.48}
        d="M10.5 92.5h97m-97 8h97m-97 8h97m-97 8h97"
      />
      <path
        d="M46.625 149v-5.818h2.227q.63 0 1.048.199.42.195.628.537.21.34.21.772 0 .356-.136.608-.136.25-.367.407a1.5 1.5 0 0 1-.514.224v.057q.31.017.594.19.287.171.469.483.181.312.182.756 0 .452-.22.812a1.5 1.5 0 0 1-.658.566q-.44.207-1.108.207zm1.054-.881h1.133q.574 0 .827-.218a.72.72 0 0 0 .255-.569.87.87 0 0 0-.49-.795 1.2 1.2 0 0 0-.563-.122h-1.162zm0-2.463h1.042q.273 0 .492-.099a.83.83 0 0 0 .343-.287.77.77 0 0 0 .128-.443.72.72 0 0 0-.238-.557q-.235-.219-.702-.219h-1.065zm6.94 1.509v-2.529h1.028V149h-.997v-.776h-.046q-.147.368-.486.6-.335.233-.827.233-.428 0-.758-.191a1.3 1.3 0 0 1-.511-.559q-.185-.37-.185-.892v-2.779h1.028v2.62q0 .414.228.659.227.244.596.244a.94.94 0 0 0 .44-.111.9.9 0 0 0 .35-.329q.14-.222.14-.554m4.264-2.529v.796h-2.508v-.796zm-1.889-1.045h1.028v4.097q0 .207.063.318.065.108.17.147.105.04.233.04a1 1 0 0 0 .301-.04l.174.804q-.083.029-.236.063-.15.034-.37.04a1.7 1.7 0 0 1-.695-.117 1.1 1.1 0 0 1-.492-.403q-.18-.273-.176-.682zm4.928 1.045v.796h-2.508v-.796zm-1.889-1.045h1.028v4.097q0 .207.063.318.065.108.17.147.105.04.233.04a1 1 0 0 0 .301-.04l.174.804q-.083.029-.236.063-.15.034-.37.04a1.7 1.7 0 0 1-.695-.117 1.1 1.1 0 0 1-.492-.403q-.18-.273-.176-.682zm4.606 5.494q-.64 0-1.108-.281a1.9 1.9 0 0 1-.727-.787q-.255-.505-.256-1.182 0-.676.256-1.184.258-.509.727-.79t1.108-.281 1.108.281.724.79q.26.508.259 1.184 0 .677-.259 1.182-.255.505-.724.787-.47.28-1.108.281m.005-.824a.9.9 0 0 0 .58-.19q.232-.193.347-.517a2.1 2.1 0 0 0 .116-.722q0-.4-.116-.724a1.15 1.15 0 0 0-.347-.52.88.88 0 0 0-.58-.193.9.9 0 0 0-.59.193 1.17 1.17 0 0 0-.35.52 2.2 2.2 0 0 0-.113.724q0 .399.113.722.117.324.35.517a.9.9 0 0 0 .59.19m3.987-1.818V149h-1.028v-4.364h.983v.742h.05q.151-.366.48-.583.333-.215.822-.215.451 0 .787.193.338.193.523.559.186.367.184.89V149h-1.028v-2.619q0-.438-.227-.685-.225-.247-.623-.247-.27 0-.48.119a.83.83 0 0 0-.326.338 1.14 1.14 0 0 0-.117.537"
        fill="#9747FF"
      />
    </g>
    <rect x={1} y={0.5} width={115} height={159} rx={11.5} stroke="#BCBBE0" />
    <defs>
      <clipPath id="a">
        <rect x={0.5} width={116} height={160} rx={12} fill="#fff" />
      </clipPath>
    </defs>
  </svg>
)

export const RbmConversationalTypeSvg = (props) => (
  <svg
    width={148}
    height={107}
    viewBox="0 0 148 107"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.93232 1.8027C4.91877 1.49471 5.14086 0 6.20017 0H78C84.0751 0 89 4.92487 89 11V11C89 17.0751 84.0751 22 78 22H22.1816C15.1921 22 9.52599 16.3339 9.52599 9.34437V6.65067C9.52599 4.41976 8.06685 2.45134 5.93232 1.8027V1.8027Z"
      fill="#D9D9D9"
    />
    <path
      d="M142.234 28.7924C143.237 28.4805 143.013 27 141.962 27H72C65.9249 27 61 31.9249 61 38V38C61 44.0751 65.9249 49 72 49H126.004C133.009 49 138.688 43.3211 138.688 36.3159V33.608C138.688 31.3996 140.125 29.448 142.234 28.7924V28.7924Z"
      fill="#E1D2FF"
    />
    <path
      d="M143.756 86.6881C144.652 86.3317 144.397 85 143.432 85H91C84.9249 85 80 89.9249 80 96V96C80 102.075 84.9249 107 91 107H127.693C134.889 107 140.722 101.167 140.722 93.9717V91.1599C140.722 89.1886 141.924 87.4166 143.756 86.6881V86.6881Z"
      fill="#E1D2FF"
    />
    <path
      d="M4.86643 56.1686C3.74886 55.6706 4.10425 54 5.32776 54H65.5C73.5081 54 80 60.4919 80 68.5V68.5C80 76.5081 73.5081 83 65.5 83H24.5627C15.7261 83 8.56269 75.8366 8.56269 67V61.8625C8.56269 59.4012 7.11452 57.1704 4.86643 56.1686V56.1686Z"
      fill="#D9D9D9"
    />
    <path
      d="M46.3534 71.6875L42.5861 67.3668C41.986 66.6787 41.6861 66.3347 41.3171 66.2187C40.9945 66.1173 40.6354 66.1231 40.3181 66.235C39.9552 66.3629 39.6727 66.7165 39.1075 67.4236L34.3378 73.3912C34.2126 73.5478 34.15 73.6262 34.1056 73.7106C34.0663 73.7855 34.0377 73.8638 34.0204 73.944C34.001 74.0343 34.001 74.1277 34.0009 74.3143L34 77H55V74.3017C55 74.1197 55 74.0287 54.9815 73.9404C54.9651 73.8621 54.9378 73.7855 54.9004 73.7121C54.858 73.6293 54.7983 73.5523 54.6788 73.3981L53.4109 71.7621C52.2903 70.3163 51.7301 69.5934 51.0019 69.3299C50.3654 69.0995 49.6417 69.0835 48.9908 69.2857C48.2461 69.5168 47.6382 70.214 46.4223 71.6084L46.3534 71.6875ZM46.3534 71.6875L51.0019 77M55 62.125C55 63.2986 53.8248 64.25 52.3751 64.25C50.9254 64.25 49.7503 63.2986 49.7503 62.125C49.7503 60.9514 50.9254 60 52.3751 60C53.8248 60 55 60.9514 55 62.125Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
